
import { useState } from 'react';
import { HeartHandshake } from 'lucide-react';
import SelectWhatsappModal from '../../SelectWhatsappModal';

export default function FinalCTA({ globeSrc = '/globe.svg', onApply }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <SelectWhatsappModal show={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <section className="py-20 px-6 bg-gradient-to-br from-boggler-teal to-boggler-blue relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 flex items-center justify-center">
          <img src={globeSrc} alt="" className="w-full h-full object-cover" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h2 className="text-4xl md:text-6xl text-white mb-6">
            Ready to Be There for Someone?
          </h2>
          <p className="text-xl md:text-2xl text-white opacity-90 mb-8 font-lato">
            Join The Boggler as a donation-based guide and help people find private conversations, shared stories, and common ground.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <button
              onClick={() => setIsModalOpen(true)}
              className="whatsapp-button bg-whatsapp-green text-white px-12 py-5 rounded-full font-montserrat font-semibold shadow-boggler btn-hover-lift inline-flex items-center gap-3"
            >
              <HeartHandshake className="w-7 h-7" aria-hidden="true" />
              Apply to Guide
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-white">
            {['Free to join', 'Donation based', 'Guide from anywhere'].map((text, i) => (
              <div key={i} className="flex items-center gap-2">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
                <span className="font-lato">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
